let _token,_loginId,_isAdmin,_isBaseUser,_allowDashBoard,_allowCharts;

export class GlobalConfig {
  // static get Token() {
  //   _token = window.localStorage.getItem("token");
  //   return _token;
  // }
  // static set Token(value) {
  //   window.localStorage.setItem("token", value);
  //   _token = window.localStorage.getItem("token");
  // }
  //
  // static get LoginId() {
  //   _loginId = window.localStorage.getItem("loginId");
  //   return _loginId;
  // }
  // static set LoginId(value) {
  //   window.localStorage.setItem("loginId", value);
  //   _loginId = window.localStorage.getItem("loginId");
  // }
  // static get isAdmin() {
  //   _isAdmin = window.localStorage.getItem("isAdmin");
  //   if(_isAdmin && _isAdmin.toString() === "true"){
  //     _isAdmin = true;
  //   }else{
  //     _isAdmin = false;
  //   }
  //   return _isAdmin
  // }
  //
  // static set isAdmin(value) {
  //   window.localStorage.setItem("isAdmin", value);
  //   _isAdmin = value;
  // }
  //
  // static get isBaseUser() {
  //   _isBaseUser = window.localStorage.getItem("isBaseUser");
  //   if(_isBaseUser && _isBaseUser.toString() === "true"){
  //     _isBaseUser = true;
  //   }else{
  //     _isBaseUser = false;
  //   }
  //   return _isBaseUser
  // }
  // static set isBaseUser(value) {
  //   window.localStorage.setItem("isBaseUser", value);
  //   _isBaseUser = value;
  // }


  static get Token() {
    localStorage.removeItem("token");
    localStorage.removeItem("loginId");
    localStorage.removeItem("isAdmin");
    localStorage.removeItem("isBaseUser");
    _token = window.localStorage.getItem("m3Ud6tML2M");
    return _token;
  }
  static set Token(value) {
    window.localStorage.setItem("m3Ud6tML2M", value);
    _token = window.localStorage.getItem("m3Ud6tML2M");
  }

  static get LoginId() {
    _loginId = window.localStorage.getItem("6am5lcYmST");

    function Decrypt(value)
    {
      let result="";
      let array = value.split("-");

      for(let i=0;i<array.length;i++)
      {
        result+=String.fromCharCode(array[i]-10);
      }
      return result;
    }

    return Decrypt(_loginId);
  }
  static set LoginId(value) {
    function Encrypt(value)
    {
      let result="";
      for(let i=0;i<value.length;i++)
      {
        if(i<value.length-1)
        {
          result+=value.charCodeAt(i)+10;
          result+="-";
        }
        else
        {
          result+=value.charCodeAt(i)+10;
        }
      }
      return result;
    }


    window.localStorage.setItem("6am5lcYmST", Encrypt(value));
    _loginId = window.localStorage.getItem("6am5lcYmST");
  }

  static get isAdmin() {
    _isAdmin = window.localStorage.getItem("cljsO1WFvl");
    if(_isAdmin && _isAdmin.toString() ===  "gia5lOGpQP"){
      _isAdmin = true;
    }else{
      _isAdmin = false;
    }
    return _isAdmin
  }

  static set isAdmin(value) {
    if(value){
      value = "gia5lOGpQP";
    }else{
      value = "2yihbQ0vjs";
    }
    window.localStorage.setItem("cljsO1WFvl", value);
    if(value == "gia5lOGpQP"){
      value = true;
    }else{
      value = false;
    }
    _isAdmin = value;
  }
// allowDashboard
  static get isBaseUser() {
    _isBaseUser = window.localStorage.getItem("rlCpxIMfp7");
    if(_isBaseUser && _isBaseUser.toString() === "xkngKow3VT"){
      _isBaseUser = true;
    }else{
      _isBaseUser = false;
    }
    return _isBaseUser
  }
  static set isBaseUser(value) {
    if(value){
      value = "xkngKow3VT";
    }else{
      value = "YvxViq6V93";
    }
    window.localStorage.setItem("rlCpxIMfp7", value);
    if(value == "xkngKow3VT"){
      value = true;
    }else{
      value = false;
    }
    _isBaseUser = value;
  }

  static get allowDashboard() {
    _allowDashBoard = window.localStorage.getItem("fytsy4Twxe");
    if(_allowDashBoard && _allowDashBoard.toString() === "oqcdow9EC"){
      _allowDashBoard = true;
    }else{
      _allowDashBoard = false;
    }
    return _allowDashBoard
  }
  static set allowDashboard(value) {
    if(value){
      value = "oqcdow9EC";
    }else{
      value = "Y8asdyoje3";
    }
    window.localStorage.setItem("fytsy4Twxe", value);
    if(value == "oqcdow9EC"){
      value = true;
    }else{
      value = false;
    }
    _allowDashBoard = value;
  }

  static get allowCharts() {
    _allowCharts = window.localStorage.getItem("kjsddc53e");
    if(_allowCharts && _allowCharts.toString() === "astsceg74gh"){
      _allowCharts = true;
    }else{
      _allowCharts = false;
    }
    return _allowCharts
  }

  static set allowCharts(value) {
    if(value){
      value = "astsceg74gh";
    }else{
      value = "Y8aATsoje3";
    }
    window.localStorage.setItem("kjsddc53e", value);
    if(value == "oqcdow9EC"){
      value = true;
    }else{
      value = false;
    }
    _allowDashBoard = value;
  }

}
